export default __webpack_public_path__ + "static/media/train_partner_2.fc064deb.png";